define('PartLookup.Model', [
  'SCModel',
  'Utils'
], function (
	SCModelComponent,
	Utils
) {
	'use strict';

	var SCModel = SCModelComponent.SCModel;

	function PartLookupModel() {
		SCModel.call(this);

		// Define properties of the model.
		this.urlRoot = function () {
			return Utils.getAbsoluteUrl(
        getExtensionAssetsPath(
          'Modules/PartLookup/SuiteScript2/PartLookup.Service.ss'
        ),
        true
      )
		};
	}

	PartLookupModel.prototype = Object.create(SCModel.prototype);

	PartLookupModel.prototype.constructor = PartLookupModel;
	debugger;
	// Return the AMD constructor.
	return PartLookupModel;
});

